import { render, staticRenderFns } from "./CrmGroupList.vue?vue&type=template&id=0046656f&scoped=true&"
import script from "./CrmGroupList.vue?vue&type=script&lang=ts&"
export * from "./CrmGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./CrmGroupList.vue?vue&type=style&index=0&id=0046656f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046656f",
  null
  
)

export default component.exports